import SanityClientConstructor from "@sanity/client";

export const client = SanityClientConstructor({
  projectId: "cludzj4m",
  dataset: "12_5",
  apiVersion: "2021-10-21",
  useCdn: true // `false` if you want to ensure fresh data
});


import {isOffline} from "./configService";
import {offlineData} from "../generated/offlineDataService";


/**
 * The main search query.
 * IF you change this please also change the offline one
 * in scripts/generate_offline_data.js
 * @type {string}
 */
export const query = `
{
  "videos": *[_type == "video"] | order(order asc) {
    _id,
    aspire,
    cut2dDesktop,
    cut2dPro,
    vcarveDesktop,
    vcarvePro,
    project->{...},
    installerFile {
      asset->{url}
    },
    relatedVideos[]{
      _type == "videoReference" => {
        "_id" : video->_id,
        "videoTitle": video-> videoTitle,
        "tutorialImage": video->tutorialImage,
        "shortDescription": video->shortDescription,
        "slug": video->slug,
        "aspire" : video->aspire,
        "cut2dDesktop" : video->cut2dDesktop,
        "cut2dPro" : video->cut2dPro,
        "vcarveDesktop" : video->vcarveDesktop,
        "vcarvePro" : video->vcarvePro,
        "trialCompatible": video->trialCompatible,
      }
    },
    difficulty,
    shortDescription,
    longDescription,
    tutorialImage,
    slug,
    trialCompatible,
    videoTitle,
    youtube ,
    bookmarks[] {
      ...,
      video->{
      
      }
    },
    videoDuration,
    category
  },
  "categories": *[_type== "category"] | order(order asc) {
    title,
    slug,
    description,
    image,
    difficulty,
    _id,
    "videos": *[_type=='video' && references(^._id)] | order(order asc){ slug, _id,aspire,cut2dDesktop,cut2dPro,vcarveDesktop,vcarvePro, difficulty, trialCompatible }
  }
  ,
  "projects": *[_type== "project"] | order(order asc) {
    slug,
    difficulty,
    description,
    projectName,
    "videos": *[_type=='video' && references(^._id)] | order(order asc) { tutorialImage, _id, slug, aspire,cut2dDesktop,cut2dPro,vcarveDesktop,vcarvePro, difficulty, trialCompatible }
  },
  "playlists": *[ _type == "playlist" ] | order(order asc) {
    description,
    slug,
    thumbnail,
    title,
    difficulty,
    videos[]{
      _type == "videoReference" => {
        "_id" : video->_id,
        "aspire" : video->aspire,
        "cut2dDesktop" : video->cut2dDesktop,
        "cut2dPro" : video->cut2dPro,
        "vcarveDesktop" : video->vcarveDesktop,
        "vcarvePro" : video->vcarvePro,
        "trialCompatible": video->trialCompatible,
        "videoTitle": video-> videoTitle,
        "tutorialImage": video->tutorialImage,
        "shortDescription": video->shortDescription,
        "slug": video->slug,
         "difficulty": video->difficulty,
      }
    }
  }
} 
`;

export function fetchVideoData() {
  if (isOffline()) {
    return new Promise((resolve) => {
      resolve(offlineData);
    });
  } else {
    console.log("Fetching from Network")
    return client.fetch(query);
  }
}

const searchquery = `
*[_type == "video" && 
  (videoTitle match $query 
   || slug.current match $query 
   || longDescription match $query 
   || shortDescription match $query
   || tags match $query)] {
    "slug": slug.current
}
`;

export function sanitySearch(querysearch) {
  console.log("Searching")
  return client.fetch(searchquery, {query: querysearch});
}
